import React from 'react'
import { format } from 'date-fns'

import { CueCard, CueCardItem } from '@components/CueCard'
import { CardContent, CardFooter } from '@components/layout/Card'
import { Button } from '@components/Button'
import { R } from '@utils/currency'

export const AssetCard = ({
  selectable,
  handleSelect,
  holding,
  highlighted,
}) => {
  const {
    error_code,
    humanised_error,
    asset_type,
    contract_number,
    currency,
    gross_value,
    name,
    monthly_contribution,
    price_date,
    provider_name,
    response_date,
    beneficiaries,
    owners,
    payers
  } = holding

  const formatValue = (value) => {
    if (value) {
      return R(value).format().replace('R', '')
    } else {
      return '-'
    }
  }

  return (
    <CueCard highlighted={highlighted}>
      <div className='ui-card__heading'>
        <h5>
          {name ? name : provider_name}
        </h5>
      </div>
      {humanised_error ? (
        <CardContent>
          <CueCardItem name={''} value={`${humanised_error} (Code ${error_code})`} />
        </CardContent>
      ) : (
        <>
          <CardContent>
            <CueCardItem name={'Asset type'} value={asset_type} />
            <CueCardItem name={'Contract number'} value={contract_number} />
            <CueCardItem name={'Currency'} value={currency} />
            <CueCardItem
              name={'Monthly contribution'}
              value={formatValue(monthly_contribution)}
            />
            <CueCardItem name={'Gross value'} value={formatValue(gross_value)} />
            <CueCardItem
              name={'Price date'}
              value={format(Date.parse(price_date), 'dd MMMM yyyy')}
            />
            {response_date &&
              <CueCardItem
                name={'Response date'}
                value={response_date}
              />
            }
            {owners && owners.length > 0 &&
              <CueCardItem
                name={'Owner'}
                value={owners.join(', ')}
              />
            }
            {payers && payers.length > 0 &&
              <CueCardItem
                name={'Payer'}
                value={payers.join(', ')}
              />
            }
            {beneficiaries && beneficiaries.length > 0 &&
              <CueCardItem
                name={'Beneficiaries'}
                value={beneficiaries.join(', ')}
              />
            }
          </CardContent>
          {selectable && (
            <CardSelectionFooter
              selected={highlighted}
              onClick={handleSelect}
            />
          )}
        </>
      )}
    </CueCard>
  )
}

const CardSelectionFooter = ({ onClick, trackAs, selected }) => (
  <CardFooter>
    <Button textLink onClick={onClick} trackAs={trackAs}>
      {selected ? 'Remove' : 'Select'}
    </Button>
  </CardFooter>
)
